
import React from 'react';
import { connect } from 'react-redux';
import Snackbar from '../snackbar/snackbar';
import { useTranslation } from 'react-i18next';

const NotFoundSnackbar = ({ error }) => {
  const { t } = useTranslation();
  const message = error === null ? '' : t('msgNotFoundSnackbar.error');
  return (
    <Snackbar show={error !== null && error !== undefined} message={message} />
  );
};

const mapStateToProps = state => ({
  error: state.application.errors.messageNotFound
});

export default connect(mapStateToProps)(NotFoundSnackbar);
